module.exports = __webpack_public_path__ + "images/sprites/ui/icon_check_failed_4945927c651e37f7a6ad85a689958ecd.png";